import { LayoutAdminTable } from '../../../../../components/templates/LayoutAdminTable';
import { InputAdornment, Stack, styled, Link, IconButton } from '@mui/material';
import { InputText } from '../../../../../components/elements/InputText';
import { ButtonCustom } from '../../../../../components/elements/ButtonCustom';
import { useInjection } from './hook';
import Typography from '@mui/material/Typography';
import theme from '../../../../../../styles/theme';
import { StyledParams } from 'types/common';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import React from 'react';
import { Autocomplete } from '@react-google-maps/api';

export const AdminTabCreate = () => {
  const {
    handleSubmit,
    register,
    errors,
    asyncCreateUser,
    fileInputDocumentRef,
    handleFileChange,
    fileDocument,
    handleDeleteDocument,
    showPassword,
    setShowPassword,
    inputRef,
    isLoaded
  } = useInjection();
  return (
    <LayoutAdminTable
      title={'New Admin'}
      textButton={'Add Document'}
      onClickButton={() => {
        if (fileInputDocumentRef.current) {
          fileInputDocumentRef.current?.click();
        }
      }}>
      <input
        accept="image/jpeg,image/png,image/jpg,application/pdf"
        ref={fileInputDocumentRef}
        hidden
        onChange={handleFileChange}
        type="file"
        multiple
      />
      <Wrapper gap={2.5} maxWidth={'900px'}>
        <Stack gap={4.5} width={'100%'} flexDirection={'row'}>
          <Stack gap={2.5} flex={1}>
            <InputText
              title={'Email'}
              inputError={errors.email?.message}
              placeholder={'Email'}
              inputProps={{
                ...register('email')
              }}
              endAdornment={
                <InputAdornment position="end" sx={{ paddingRight: '8px' }}>
                  <img alt={'user'} src={'/icons/icon_email.svg'} />
                </InputAdornment>
              }
            />
            <InputText
              title={'Password'}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? (
                      <Visibility sx={{ color: '#22374A' }} />
                    ) : (
                      <VisibilityOff sx={{ color: '#22374A' }} />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              inputError={errors.password?.message}
              inputProps={{
                ...register('password'),
                type: showPassword ? 'text' : 'password'
              }}
              placeholder={'Password'}
            />
            {isLoaded && (
              <Autocomplete>
                <InputText
                  inputError={errors.address?.message}
                  placeholder={'Address'}
                  title={'Address'}
                  inputRef={inputRef}
                  inputProps={{
                    ...register('address')
                  }}
                />
              </Autocomplete>
            )}
            <Stack gap={1.25}>
              <Typography fontWeight={500} mb={1} fontSize={'13px'} color={theme.colors.dark1}>
                Documents
              </Typography>
              {fileDocument.map((doc, index) => (
                <Stack
                  key={index}
                  flexDirection={'row'}
                  alignItems={'center'}
                  justifyContent={'space-between'}>
                  <Stack flexDirection={'row'} gap={1.5} alignItems={'center'}>
                    <img src={'/icons/icon_document.svg'} alt={'icon'} />
                    <NameDocument href={doc.url} target={'_blank'}>
                      {doc.file.name}
                    </NameDocument>
                  </Stack>
                  <img
                    onClick={() => handleDeleteDocument(index)}
                    style={{ cursor: 'pointer' }}
                    src={'/icons/icon_delete_file.svg'}
                    alt={'icon'}
                  />
                </Stack>
              ))}
            </Stack>
          </Stack>
          <Stack gap={2.5} flex={1}>
            <InputText
              title={'First Name'}
              inputError={errors.firstName?.message}
              placeholder={'First Name'}
              inputProps={{
                ...register('firstName')
              }}
            />
            <InputText
              title={'Last Name'}
              inputError={errors.lastName?.message}
              placeholder={'Last Name'}
              inputProps={{
                ...register('lastName')
              }}
            />
          </Stack>
        </Stack>
        <ButtonCustom
          style={{ width: '250px', marginTop: '20px' }}
          onClick={handleSubmit(asyncCreateUser)}
          label={'Create'}
        />
      </Wrapper>
    </LayoutAdminTable>
  );
};

const Wrapper = styled(Stack)(() => ({
  gap: '20px',
  padding: '40px 30px',
  border: '1px solid #ccc',
  borderRadius: '20px',
  alignItems: 'center'
}));
const NameDocument = styled(Link)(({ theme }: StyledParams) => ({
  color: theme.colors.dark1,
  fontSize: 13,
  fontWeight: 500,
  lineHeight: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 'calc(100% - 24px)'
}));
